<script setup lang="ts">
import RcMinersSelect from '@/components/rc/common/RcMinersSelect.vue'
import type { IMinerIdentifier } from '@/types/rc/miners'
import { ref } from 'vue'

const selectRef = ref<InstanceType<typeof RcMinersSelect>>()

const selection = defineModel<undefined | IMinerIdentifier | IMinerIdentifier[]>({ required: true })
const props = withDefaults(
  defineProps<{
    workOrderNumber?: string
    multiple?: boolean
  }>(),
  { workOrderNumber: undefined, multiple: true }
)

const reset = () => {
  selectRef.value?.reset()
}

defineExpose({ reset })
</script>

<template>
  <RcMinersSelect
    ref="selectRef"
    v-model="selection"
    :filters="{ work_order_number: props.workOrderNumber }"
    :multiple="multiple"
  />
</template>
